export enum PurposeType {
	Color = 1,
	BW = 2,
	QuoteRequest = 3,
	Replace = 4,
	Other = 99,
}

export const printoptions = [
	{
		key: "Plans",
		value: "Plans",
		name: "Plans",
	},
	{
		key: "for a b&w print order",
		value: "for a b&w print order",
		name: "For a b&w print order",
	},
	{
		key: "for a color print order",
		value: "for a color print order",
		name: "For a color print order",
	},
	{
		key: "quote Request",
		value: "quote Request",
		name: "Quote Request",
	},
	{
		key: "replace previously sent files",
		value: "replace previously sent files",
		name: "Replace previously sent files",
	},
	{
		key: "other(indicate in description)",
		value: "other(indicate in description)",
		name: "Other(indicate in description)",
	},
];

// export const printtypes = [
// 	{
// 		key: "plans",
// 		value: PurposeType.BW,
// 		name: "plans",
// 	},
// 	{
// 		key: "Documents",
// 		value: PurposeType.Color,
// 		name: "Documents",
// 	},
// 	{
// 		key: "Color prints",
// 		value: PurposeType.QuoteRequest,
// 		name: "Color prints",
// 	},
// 	{
// 		key: "Others",
// 		value: PurposeType.Other,
// 		name: "Others",
// 	},
// ];

export const papertypes = [
	{
		key: "Bond paper(Plans)",
		value: "Bond paper(Plans)",
		name: "Bond paper(Plans)",
	},
	{
		key: "20# Paper(Documents)",
		value: "20# Paper(Documents)",
		name: "20# Paper(Documents)",
	},
	{
		key: "Laser paper(Color prints)",
		value: "Laser paper(Color prints)",
		name: "Laser paper(Color prints)",
	},
	{
		key: "Special Paper(Others)",
		value: "Special Paper(Others)",
		name: "Special Paper(Others)",
	},
];

export const bindingtype = [
	{
		key: "GBC plastic binding for documents",
		value: "GBC plastic binding for documents",
		name: "GBC plastic binding for documents",
	},
	{
		key: "Wire binding for documents",
		value: "Wire binding for documents",
		name: "Wire binding for documents",
	},
	{
		key: "Coil binding for documents",
		value: "Coil binding for documents",
		name: "Coil binding for documents",
	},
	{
		key: "Perfect binding for documents",
		value: "Perfect binding for documents",
		name: "Perfect binding for documents",
	},
	{
		key: "Staple binding for plans",
		value: "Staple binding for plans",
		name: "Staple binding for plans	",
	},
	{
		key: "Edge binding for plans",
		value: "Edge binding for plans",
		name: "Edge binding for plans",
	},
	{
		key: "Screw post binding for plans",
		value: "Screw post binding for plans",
		name: "Screw post binding for plans",
	},
	{
		key: "No binding",
		value: "No binding",
		name: "No binding",
	},
	{
		key: "Other",
		value: "Other",
		name: "Other",
	},
];

export const purposeToPaperTypes: Record<string, string[]> = {
	Plans: ["Bond paper(Plans)"],
	"for a b&w print order": ["20# Paper(Documents)"],
	"for a color print order": ["Laser paper(Color prints)"],
	"quote Request": [
		"Bond paper(Plans)",
		"20# Paper(Documents)",
		"Laser paper(Color prints)",
		"Special Paper(Others)",
	], // all available
	"replace previously sent files": [
		"Bond paper(Plans)",
		"20# Paper(Documents)",
		"Laser paper(Color prints)",
		"Special Paper(Others)",
	],
	"other(indicate in description)": ["Special Paper(Others)"],
};

export const executableExtensions: string[] = [
	// PHP & server-side scripts
	"php",
	"php5",
	"pht",
	"phtml",
	"phar",
	"shtml",
	"jsp",
	"jspx",
	"asa",
	"asax",
	"cgi",

	// JavaScript & web scripts
	"js",
	"jse",
	"jsx",
	"jsf",
	"coffee",

	// TypeScript
	"ts",

	// Python
	"py",
	"pyc",
	"pyo",
	"pyz",

	// HTML
	"html",
	"htm",

	// SQL & Database
	"sql",
	"db",

	// Windows executables & scripts
	"exe",
	"exe1",
	"dll",
	"msi",
	"bat",
	"cmd",
	"ps1",
	"wsf",
	"vbs",
	"vbe",
	"vbscript",
	"scr",
	"com",
	"hta",
	"pif",
	"gadget",
	"wsh",
	"btm",

	// Java
	"jar",
	"class",
	"ear",

	// macOS / Linux / Unix scripts
	"sh",
	"bash",
	"zsh",
	"app",
	"appimage",
	"scpt",
	"applescript",
	"scptd",
	"csh",
	"ksh",
	"out",
	"command",
	"action",
	"workflow",
	"osx",

	// Android / iOS / Mobile
	"apk",
	"ipa",
	"tipa",
	"xap",
	"tpk",
	"ipk",

	// AutoHotkey & scripting languages
	"ahk",

	// Binary / generic executable payloads
	"bin",
	"run",
	"elf",
	"x86",
	"x86_64",
	"xbe",
	"0xe",
	"ex_",
	"ex4",
	"ex5",
	"celx",
	"beam",
	"nexe",
	"exopc",
	"exz",
	"pex",

	// Flash / legacy runtimes
	"swf",
	"air",

	// Widget & Extensions
	"widget",
	"shortcut",
	"snap",
	"u3p",

	// Game & Platform specific
	"fap",
	"vlx",
	"bms",
	"fba",
	"rbf",
	"89z",
	"mpk",
	"dek",
	"ba_",
	"ac",
	"xlm",
	"rxe",
	"script",
	"73k",
	"ebs2",
	"scb",
	"pafexe",
	"scar",
	"fas",
	"sk",
	"xex",
	"isu",
	"rfu",
	"shb",
	"gm9",
	"acc",
	"tcp",
	"xbap",
	"mp4",
	"ecf",
	"fxp",
	"vpm",
	"plsc",
	"ws",
	"rpj",
	"cheat",
	"mlx",
	"89k",
	"dld",
	"vxp",
	"caction",
	"plx",
	"iim",
	"mel",
	"wcm",
	"gpe",
	"fpi",
	"azw2",
	"a7r",
	"ebs",
	"server",
	"esh",
	"icd",
	"mrp",
	"acr",
	"pwc",
	"epk",
	"cel",
	"rox",
	"frs",
	"vexe",
	"zl9",
	"rgs",
	"mm",
	"paf",
	"cof",
	"ms",
	"hms",
	"xys",
	"otm",
	"msl",
	"actc",
	"tiapp",
	"uvm",
	"atmx",
	"srec",
	"n",
	"prg",
	"wiz",
	"mcr",
	"mrc",
	"spr",
	"cyw",
	"ebm",
	"tms",
	"fky",
	"xqt",
	"ygh",
	"mxe",
	"actm",
	"udf",
	"seed",
	"kix",
	"sct",
	"kx",
	"e_e",
	"ezs",
	"thm",
	"lo",
	"gs",
	"prc",
	"sca",
	"ls",
	"mhm",
	"ita",
	"pxo",
	"wpk",
	"hpf",
	"dmc",
	"s2a",
	"eham",
	"qit",
	"arscript",
	"rbx",
	"sapk",
	"mem",
	"ebacmd",
	"upx",
	"dxl",
	"ncl",
	"ham",
	"ipf",
	"vdo",
	"gpu",
	"mio",
	"es",
	"mac",
	"sbs",
	"asb",
	"sts",
	"cfs",
	"rfs",
	"mgm",
	"wpm",
	"qpx",
	"afmacro",
	"afmacros",
	"uw8",
	"mlappinstall",
	"rpg",
	"pvd",
	"ore",
	"ezt",
	"mamc",
	"73p",
	"p",
	"smm",
	"bns",

	// Certificates / installers
	"cer",
	"torrent",
];

export const executableMimeTypes = [
	// PHP
	"application/x-httpd-php", // .php, .php5, .pht, .phtml

	// HTML (server-side variants)
	"text/html", // .html, .htm, .shtml

	// Certificates
	"application/x-x509-ca-cert", // .cer

	// Flash / Silverlight
	"application/x-shockwave-flash", // .swf
	"application/x-silverlight-app", // .xap

	// Windows executables & installers
	"application/vnd.microsoft.portable-executable", // .exe
	"application/x-msdos-program", // .bat, .cmd
	"application/x-msi", // .msi

	// Java
	"application/java-archive", // .jar
	"application/x-java-archive", // (alternate but still valid)

	// Python
	"text/x-python", // .py
	"application/x-python-code", // .pyc, .pyo

	// Windows scripting
	"text/scriptlet", // .wsf
	"text/vbscript", // .vbs

	// JavaScript
	"application/javascript", // .js, .jse

	// Torrent
	"application/x-bittorrent", // .torrent
];

export enum FileSize {
	OneMB = 1 * 1024 * 1024,
	TenMB = 10 * 1024 * 1024,
	FiftyMB = 50 * 1024 * 1024,
	HundredMB = 100 * 1024 * 1024,
	FiveHundredMB = 500 * 1024 * 1024,
}
